// extracted by mini-css-extract-plugin
export default {"menulist":"Menu_menulist__RHwJ9","active":"Menu_active__Hazbj"};